import React, { Component } from 'react';

class Auth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {}
        }
    }

    componentDidMount() {
        try {
            const user = JSON.parse(sessionStorage.getItem('user'));
            this.setState({
                user
            });
        } catch (error) {
            console.error(error);
            this.setState({
                user: {}
            });
        }
    }

    // 获取深度嵌套json
    getJson = (arr = [], obj = {}) => {
        return arr.reduce((a, b) => a && a[b] ? a[b] : '', obj);
    }

    render() {
        const user = this.state.user; 
        if (this.getJson(['email'], user).toUpperCase().includes('DOO')) {
            return this.props.children;
        }
        // 判断是否有管理员权限
        if (!this.getJson(['email'], user).toUpperCase().includes('ADMIN')) {
            return null
        }

        if (!this.getJson(['email'], user).toUpperCase().includes(this.props.name) && this.getJson(['email'], user).toUpperCase() != 'ADMIN') {
            return null
        }
        return this.props.children;
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/bp-views/comments/Auth.js